//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AnimatedLink from '../common/AnimatedLink.vue'
export default {
  components: {
    AnimatedLink
  },
  props: {
    imgPath: {
      type: String,
      default: null
    },
    imgSize: {
      type: String,
      default: 'fixed'
    },
    title: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: null
    },
    showLink: {
      type: Boolean,
      default: false
    },
    link: {
      type: String,
      default: ''
    },
    linkText: {
      type: String,
      default: ''
    },
    linkType: {
      type: String,
      default: 'internal-link'
    },
    linkTextColor: {
      type: String,
      default: null
    },
    addBg: {
      type: Boolean,
      default: false
    },
    h2: {
      type: Boolean,
      default: false
    }
  }
}
